<template>
  <div class="dot-spinner">
    <div
      v-for="dotIndex in totalDots"
      :key="dotIndex"
      class="dot-spinner__dot"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'BaseDotSpinner',
  props: {
    totalDots: {
      type: Number,
      default: 8
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/spinner/BaseDotSpinner.vue